import UrlParse from "url-parse";
import { RivalsAppProps, RivalsPageProps } from "rivals/Context";
import Login from "rivals/components/pages/User/Login";
import { HOST_BASE_PATH } from "rivals/services/base";

interface OwnProps {
  referrerURI?: string;
  showAuthenticatedLinks: boolean;
}

type Props = RivalsPageProps & OwnProps;

function SignInPage({ referrerURI }: Props): JSX.Element {
  return (
    <main role="main">
      <Login referrerURI={referrerURI} />
    </main>
  );
}

SignInPage.getInitialProps = async ({
  req,
  isServer
}: RivalsAppProps): Promise<Props> => {
  let referrerURI: string | undefined;
  let forumReturnTo = "";

  function checkProtocolValid(protocol: string): boolean {
    return (
      (protocol && (protocol === "http:" || protocol === "https:")) || !protocol
    );
  }

  function checkHostnameValid(hostname: string): boolean {
    return (
      (hostname && !!hostname.match(`^(.+\\.)?${HOST_BASE_PATH}$`)) || !hostname
    );
  }
  const parsedUrl = req && req.url ? new UrlParse(req.url, true) : "";
  if (parsedUrl) {
    const returnTo = parsedUrl.query["return_to"]
      ? new UrlParse(parsedUrl.query["return_to"])
      : "";
    // Any path that is only alphanumeric, /, -, _, and . is allowed. (Note: literal . not regex wildcard)
    // This might theoretically break a very small subset of valid site urls,
    // but preventing injection is more important than preserving that functionality
    if (
      returnTo &&
      returnTo.pathname.match("^[A-z0-9-_./]*$") &&
      checkProtocolValid(returnTo.protocol) &&
      checkHostnameValid(returnTo.hostname)
    ) {
      // Only redirect if the host matches us or if it's a path only
      forumReturnTo = encodeURI(returnTo.href);
    }
  }

  if (forumReturnTo !== "") {
    referrerURI = forumReturnTo;
  } else if (isServer && req) {
    referrerURI = req.headers.referer;
  } else if (!isServer) {
    referrerURI = window.document.URL;
  }

  return {
    isServer,
    referrerURI,
    showAuthenticatedLinks: false
  };
};

export default SignInPage;
